export default __webpack_public_path__ + "static/media/wovenfloor.10dbe05b.png";